import { type Language } from "./translations";

export const routes = {
  home: {
    pl: "",
    en: "",
    de: "",
  },
  privacyPolicy: {
    pl: "polityka-prywatnosci",
    en: "privacy-policy",
    de: "datenschutz",
  },
  terms: {
    pl: "regulamin",
    en: "terms-of-service",
    de: "agb",
  },
  catalog: {
    pl: "katalog",
    en: "catalog",
    de: "katalog",
  },
  // Dynamic routes with parameters need special handling or just defined as base path
  services: {
    bus: {
      pl: "uslugi/sterowniki-autobusy",
      en: "services/bus-ecus",
      de: "dienstleistungen/bus-steuergeraete",
    },
    agricultural: {
      pl: "uslugi/sterowniki-maszyny-rolnicze",
      en: "services/agricultural-machinery-ecus",
      de: "dienstleistungen/landmaschinen-steuergeraete",
    },
    construction: {
      pl: "uslugi/sterowniki-maszyny-budowlane",
      en: "services/construction-machinery-ecus",
      de: "dienstleistungen/baumaschinen-steuergeraete",
    },
    mercedes: {
      pl: "uslugi/sterowniki-mercedes-benz",
      en: "services/mercedes-benz-ecus",
      de: "dienstleistungen/mercedes-benz-steuergeraete",
    },
    man: {
      pl: "uslugi/sterowniki-man",
      en: "services/man-ecus",
      de: "dienstleistungen/man-steuergeraete",
    },
    trailer: {
      pl: "uslugi/sterowniki-naczepy",
      en: "services/trailer-ecus",
      de: "dienstleistungen/auflieger-steuergeraete",
    },
  },
} as const;

export const getRoute = (
  key: string,
  lang: Language
): string => {
  const parts = key.split(".");
  if (parts[0] === "services" && parts.length === 2) {
    const serviceKey = parts[1] as keyof typeof routes.services;
    return routes.services[serviceKey][lang];
  }
  if (parts.length === 1 && key in routes) {
      return (routes as any)[key][lang];
  }
  return key;
};
